import { Component, ViewEncapsulation, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { NotificationsService } from '@vestiaire/api-sdk-angular';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import {
  SetCountersNotifications,
  SET_COUNTERS_NOTIFICATIONS_RESET
} from '@app/core/header/store/actions/header.action';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { MmaoService } from '@app/shared/components/mmao/services/mmao.service';
import { MmaoPopinComponent } from '@app/shared/components/mmao/mmao-popin/mmao-popin.component';
import { MatDialog } from '@angular/material/dialog';
import { NotificationEvent } from '@vestiaire/wc-notification/types';
import { TrackingService } from '@app/analytics/services/tracking.service';

@Component({
  selector: 'vc-notifications',
  templateUrl: 'notifications.component.html',
  styleUrls: ['notifications.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NotificationsComponent implements OnChanges {
  @Input()
  isShow;
  @Input()
  showHeader: boolean;
  @Input()
  defaultCategory: any;
  @Input()
  activableNotifications = false;
  @Input()
  channelId: string;

  @Output()
  onClosePreviewBox: EventEmitter<void> = new EventEmitter();
  @Output()
  displayListMobile: EventEmitter<boolean> = new EventEmitter<boolean>();

  notifications: any;
  loading = false;

  notificationV2 = environment.feature.notification_v2;
  notificationCenterConfig = {
    env: environment.envName,
    globaldesignsystemLink:
      environment.assetsPath + 'design-system/' + environment.designSystemVersion + '/main.min.css'
  };

  constructor(
    private notificationsService: NotificationsService,
    private store: Store<IAppState>,
    private router: Router,
    private mmaoService: MmaoService,
    public dialog: MatDialog,
    private trackingService: TrackingService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isShow && changes.isShow.currentValue && !this.notificationV2) {
      this.loading = true;
      this.getNotifications();
    }
  }

  onNotificationClickHandler($event: NotificationEvent) {
    const { link, negotiationId, tracking, openChatFromLike } = $event;
    if (tracking) {
      this.sendTrackingEvent(tracking);
    }

    if (negotiationId) {
      this.openNegotiatingArea(negotiationId);
    } else if (link && link.path) {
      const chatUrl = openChatFromLike ? `${link.path}&community=true` : link.path;
      this.router.navigateByUrl(chatUrl);
    }
    this.onClosePreviewBox.emit();
  }

  onFilterChanged($event) {
    const { tracking } = $event;
    if (tracking) {
      this.sendTrackingEvent(tracking);
    }
  }

  sendTrackingEvent(payload) {
    if (payload) {
      this.trackingService.send({
        type: 'event',
        payload
      });
    }
  }

  setCounter($event) {
    this.store.dispatch(new SetCountersNotifications($event));
  }

  openNegotiatingArea(id: string): void {
    this.mmaoService.getNegotiation(id).subscribe(
      negotiation => {
        this.dialog.open(MmaoPopinComponent, {
          maxWidth: 600,
          data: {
            product: negotiation.product,
            negotiation: negotiation
          }
        });
      },
      err => console.log(err)
    );
  }

  getNotifications() {
    this.notificationsService.listNotifications().subscribe(
      res => {
        this.loading = false;
        this.notifications = res.data;
        this.store.dispatch({ type: SET_COUNTERS_NOTIFICATIONS_RESET });
      },
      error => {
        console.log(error);
      }
    );
  }
}
